import React, { useState } from 'react';
import { Drawer, Typography, IconButton, Grid, Button, TextField, Tabs, Tab, Box } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { customtheme } from '../../../app/theme/theme';
import { handleReturnValue, handleReturnValueSigEmp } from '../../../common/functions/returnValue';
import { mapperToPurchaseRequestItem } from '../../../app/mappers/purchase-request/purchase-request.mapper';
import PurchaseRequestEmitItemDialog from '../PurchaseRequestEmitItemDialog';

const useStyles = makeStyles((theme) => ({
  drawer: { width: 500 },
  drawerHeader: {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tabsBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  drawerContent: {
    overflowY: 'auto',
    padding: theme.spacing(2),
    height: '100%',
  },
  drawerFooterBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
  },
  drawerFooter: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    background: customtheme.gray[200],
  },
  textField: {
    minWidth: 140,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  searchIcon: {
    marginRight: theme.spacing(1),
    color: customtheme.blue[500],
  },
  title: {
    color: customtheme.blue[500],
  },
  backgroundColor: {
    background: customtheme.blue[500],
    color: customtheme.white,
    '&:hover': { background: customtheme.blue[50], color: customtheme.blue[500] },
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
  fields: any[];
  setFields: (array: any[]) => void;
  handleOpenDialogSearch: (data: any) => void;
  checkPrevCompanyValue: { exists: boolean, value: any };
  checkPrevBranchValue: { exists: boolean, value: any };
  isLoading?: boolean;
  handleCheckFields: () => void;
  setIsSnackbar: (snackBarProps: {open: boolean, message: string, title: string}) => void;
}

const PurchaseRequestEmitDrawer: React.FC<Props> = ({ open, onClose, fields, setFields, handleOpenDialogSearch, checkPrevCompanyValue, checkPrevBranchValue, isLoading, handleCheckFields, setIsSnackbar }) => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTab(newValue);
  };

  const fieldsInit = mapperToPurchaseRequestItem({})
    const [openItemDrawer, setOpenItemDrawer] = useState({ open: false, item: fieldsInit, index: -1});
    const handleCloseItemDrawer = () => setOpenItemDrawer({ open: false, item: fieldsInit, index: -1});
    const handleOpenItemDrawer = (item: any, index: number) => setOpenItemDrawer({ open: true, item, index: index});
  
  const handleCheckFieldsItem = (itemFields: any) => {
    const requireds = itemFields.filter((field:any) => field.required)
    if(requireds.length !== requireds.filter((required:any) => required.value).length) {
      setIsSnackbar({open:true, message: 'Por favor, adicione os campos obrigatórios!', title: 'error'})
    } else { 
      const upd = [...fields];
      const itensForm = upd[upd.findIndex(f => f.id === 'itens')]
      const values = [...itensForm.value];
      if (openItemDrawer.index === -1) {
        values.push(itemFields);
      } else {
        values[openItemDrawer.index] = itemFields;
      }
      itensForm.value = values
      setFields(upd);
      handleCloseItemDrawer();
    }
  }

  const setLowerKeys = (array: Array<any>) => {
    const arrChecked = !Array.isArray(array) ? [array] : array;
    return arrChecked.map(r =>
      Object.entries(r).reduce((acc: any, [key, value]: any) => {
        acc[key.toLowerCase()] = value;
        return acc;
      }, {}),
    );
  };

  const readItemValue = (item: any, fieldId: string, subKey?: string) => {
    // If item is an array of fields
    if (Array.isArray(item)) {
      const f = item.find((field: any) => field.id === fieldId);
      if (!f) return null;
      if (!subKey) return f.value;
      return f.value ? f.value[subKey] : null;
    }

    // If item is already a plain object
    if (item[fieldId] !== undefined) return item[fieldId];
    // special-case mapped flat names (despro/codpro or desitem/coditem)
    if (subKey) return item[subKey] !== undefined ? item[subKey] : null;
    return null;
  }

  return (
    <Drawer anchor="right" open={open} onClose={onClose} classes={{ paper: classes.drawer }}>
        <div className={classes.drawerHeader}>
          <Typography variant="h6">Solicitação</Typography>
          <IconButton onClick={onClose}><CloseIcon /></IconButton>
        </div>
        <div className={classes.drawerContent}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Tabs
                value={tab}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
                className={classes.tabsBar}
              >
                <Tab label="Dados" />
                <Tab label="Produtos" />
              </Tabs>

              <Box mt={2}>
                {tab === 0 && (
                      <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
              label="Empresa"
              onClick={() => handleOpenDialogSearch({
              id: 'dados',
              title: 'Empresa',
              keySub: 'sigemp',
              key: 'codemp',
              prevDataSearch: {},
              hasButtonCreate: false,
              })}
              value={
                  handleReturnValueSigEmp('dados', fields)                 
              }
              fullWidth
              className={classes.textField}
              InputProps={{
                endAdornment: (
                    <IconButton
                    className={classes.searchIcon}
                    onClick={() => handleOpenDialogSearch({
                        id: 'dados',
                        title: 'Empresa',
                        keySub: 'sigemp',
                        key: 'codemp',
                        prevDataSearch: {},
                        hasButtonCreate: false,
                        })}>
                    <SearchIcon />
                    </IconButton>
                ),
              }}
            />
                </Grid>
                <Grid item xs={12}>
                  <TextField
              label="Filial"
              onClick={
              () => checkPrevCompanyValue.exists ? 
                  handleOpenDialogSearch({
                  id: 'filiais', 
                  title: 'Filial', 
                  keySub: 'nomfil', 
                  key: 'codfil',
                  isPrevSearch: true,
                  prevSearch: setLowerKeys(fields.filter((field) => field.id === 'dados')[0].value?.filiais || []),
                  prevDataSearch: {},
                  hasButtonCreate: false,
                  }) 
                  : () => {}
              }
              value={
                  checkPrevCompanyValue.exists ?
                      handleReturnValue('filiais', fields)
                  : 'Selecione uma empresa primeiro'
              }
              fullWidth
              className={classes.textField}
              disabled={
                checkPrevCompanyValue.exists ? false : true
              }
              InputProps={{
              endAdornment: (
                  <IconButton
                  className={classes.searchIcon}
                  onClick={() => checkPrevCompanyValue.exists ? 
                      handleOpenDialogSearch({
                      id: 'filiais', 
                      title: 'Filial', 
                      keySub: 'nomfil', 
                      key: 'codfil',
                      isPrevSearch: true,
                      prevSearch: setLowerKeys(fields.filter((field) => field.id === 'dados')[0].value?.filiais || []),
                      prevDataSearch: {},
                      hasButtonCreate: false,
                      }) : 
                      () => {}
                  }
                  disabled={
                    checkPrevCompanyValue.exists ? false : true
                  }
                  >
                  <SearchIcon />
                  </IconButton>
                ),
              }}
            />
                </Grid>
              </Grid>
                )}

                {tab === 1 && (
                  <>
                    {
                      openItemDrawer.open &&
                        <PurchaseRequestEmitItemDialog
                          onClose={handleCloseItemDrawer}
                          fieldsInit={openItemDrawer.item}
                          handleUpdateValue={(itens) => {
                            handleCheckFieldsItem(itens)
                          }}
                          isOpen={openItemDrawer.open}
                          checkPrevCompanyValue={checkPrevCompanyValue}
                          checkPrevBranchValue={checkPrevBranchValue}
                        />
                    }
                    {/* Button to add item */}
                    <Button
                      variant="contained"
                      className={classes.backgroundColor}
                      onClick={() => handleOpenItemDrawer(fieldsInit, -1)}
                    >
                      Adicionar item
                    </Button>

                    {/* List items */}
                    {
                      fields.find(f => f.id === 'itens').value.map((item: any, index: number) => {
                        const desc = readItemValue(item, 'produto', 'despro') || readItemValue(item, 'servico', 'desser') || readItemValue(item, 'desitem') || readItemValue(item, 'despro') || '';
                        const code = readItemValue(item, 'produto', 'codpro') || readItemValue(item, 'servico', 'codser') || readItemValue(item, 'coditem') || readItemValue(item, 'codpro') || '';
                        const tipo = readItemValue(item, 'tipo')?.tipo || readItemValue(item, 'tipo');
                        const qtd = readItemValue(item, 'qtdsol')?.qtdsol || readItemValue(item, 'qtd') || '';
                        const uni = readItemValue(item, 'unimed') || readItemValue(item, 'unidademedida') || readItemValue(item, 'uniMed') || '';
                        const presol = readItemValue(item, 'presol')?.presol || '';
                        const seqsol = readItemValue(item, 'seqsol')?.seqsol || '';
                        const datprv = readItemValue(item, 'datprv')?.datprv || '';
                        const obssol = readItemValue(item, 'obssol')?.obssol || readItemValue(item, 'obsSol') || '';
                        const centro = readItemValue(item, 'centrosCusto') || readItemValue(item, 'centroCusto') || {};
                        const codccu = centro?.codccu || centro?.codcu || '';
                        const desccu = centro?.desccu || centro?.desccu || '';
                        const valortotal = qtd && presol ? `R$ ${(qtd * presol).toFixed(2)}` : 'R$ 0,00';

                        return (
                          <Grid key={index} container spacing={2} alignItems="center" style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 8, marginBottom: 16 }}>
                            <Grid item xs={12} sm={6}>
                              <Typography variant="h6" className={classes.title}>{desc}</Typography>
                              <Typography variant="body2">Código: {code}</Typography>
                              <Typography variant="body2">Tipo: {tipo}</Typography>
                              <Typography variant="body2">Qtd: {qtd} • Uni: {uni}</Typography>
                              <Typography variant="body2">Presol: {presol} • Seq: {seqsol}</Typography>
                              <Typography variant="body2">Data Prevista: {datprv}</Typography>
                              <Typography variant="body2">Centro de Custo: {codccu} {desccu ? `- ${desccu}` : ''}</Typography>
                              {obssol ? <Typography variant="body2">Obs: {obssol}</Typography> : null}
                            </Grid>
                            <Grid item xs={12} sm={6} container direction="column" alignItems="flex-end" spacing={1}>
                              <Grid item>
                                <Typography variant="subtitle1">Valor total: {valortotal}</Typography>
                              </Grid>
                              <Grid item>
                                <Button
                                  variant="outlined"
                                  onClick={() => handleOpenItemDrawer(item, index)}
                                >
                                  Editar
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={() => {
                                    const upd = [...fields];
                                    const itensForm = upd[upd.findIndex(f => f.id === 'itens')];
                                    const values = itensForm.value.filter((_: any, i: number) => i !== index);
                                    itensForm.value = values;
                                    setFields(upd);
                                  }}
                                >
                                  Remover
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        )
                      })
                    }
                  </>
                )}
              </Box>
            </Grid>
          </Grid>
        </div>
      <div className={classes.drawerFooterBox}>
        <Box className={classes.drawerFooter}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>Voltar</Button>
          <Button variant="contained" color="primary" onClick={handleCheckFields} disabled={isLoading}>
            {isLoading ? 'Salvando...' : 'Salvar'}
          </Button>
        </Box>
      </div>
    </Drawer>
  )
}

export default PurchaseRequestEmitDrawer;
